/**
 * app.tsx — root component.
 *
 * Wraps AppRoutes in the BrowserRouter. QueryClient and ThemeProvider live in
 * main.tsx so this file stays focused on routing composition.
 */
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { UpdateAvailableBanner } from './shared';

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      {/* Outside AppRoutes so a stale *login* page is covered too — a client
          running an old bundle against a changed contract cannot sign in far
          enough to be told anything. */}
      <UpdateAvailableBanner />
    </BrowserRouter>
  );
}
